import { Button } from "@/components/shadcn/button";
import { Moon, Sun } from "lucide-react";

const ThemeToggle = () => {
  const toggleTheme = () => {
    document.body.classList.toggle("dark");
  };

  return (
    <Button
      onClick={toggleTheme}
      size="icon"
      className="grid"
      variant="outline"
    >
      <Sun className="text-foreground scale-100 [grid-area:1/1] dark:scale-0" />
      <Moon className="text-foreground scale-0 [grid-area:1/1] dark:scale-100" />
    </Button>
  );
};

export default ThemeToggle;
